import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "../components/Layout";
import ProgressButton from "../components/ProgressButton";

const Failed = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Card>
        <h1 style={{ color: "red" }}>❌ Betaling mislykkedes!</h1>
        <p>Vi beklager, din betaling kunne ikke gennemføres.</p>
        <ProgressButton
          onClick={() => navigate("/")}
          text="Gå tilbage til forsiden"
        />
      </Card>
    </Container>
  );
};

export default Failed;
